<template>
  <Collapse class="main-nav__sub-nav" ref="collapse">
    <ul>
      <li v-for="link in links" :key="link.name">
        <a
          v-if="link.external"
          :href="link.url"
          target="_blank"
          rel="nofollow me noopener noreferrer"
        >
          <i v-html="icons[link.icon]"></i> {{ link.name }}
        </a>
        <router-link v-else :to="link.url" :exact="link.exact">
          <i v-html="icons[link.icon]"></i> {{ link.name }}
        </router-link>
      </li>
    </ul>
  </Collapse>
</template>

<script>
import Collapse from "../common/Collapse";

import AngleDown from "../../assets/icons/angle-down.svg";
import desktop from "../../assets/icons/desktop.svg";
import mobile from "../../assets/icons/mobile.svg";

export default {
  name: "main-nav-sub-list",
  props: {
    links: {
      type: Array
    }
  },
  components: {
    Collapse
  },
  data() {
    return {
      AngleDown,
      icons: {
        desktop: desktop,
        mobile: mobile
      }
    };
  },
  methods: {
    toggle() {
      this.$refs.collapse.toggle();
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../assets/styles/vars";
@import "../../assets/styles/mixins";

.main-nav__sub-nav {
  text-align: left;
  transition: all 0.2s ease-in-out;

  // because we have mobile and desktop navigation, with different kind of animation,
  // we'll just separate them by media query
  @media (min-width: $screen-md) {
    position: absolute;
    right: 0;
    background-color: rgba(255, 255, 255, 0.67);
    visibility: hidden;
    transform-origin: 0 0;
    transform: scaleY(0);
    display: block !important; // overriding collapse default styles
  }

  @media (max-width: $screen-sm-max) {
    padding-left: 1em;
  }

  ul {
    margin: 0;
    padding: 0;
    list-style-type: none;

    @media (max-width: $screen-sm-max) {
      padding-top: 25px;
      padding-bottom: 25px;
    }
  }

  li {
    line-height: 3;
    padding: 0 14px;

    &:first-child {
      margin-top: 0.3em;
    }

    @media (max-width: $screen-sm-max) {
      margin: 0;
      line-height: 1;
      padding: 0;
      display: block;

      &:not(:last-child) {
        padding-bottom: 25px;
      }
    }
  }

  a {
    text-decoration: none;
    font-size: 1em !important;
    white-space: nowrap;
    color: #1a1a1a;
    transition: color $linkTransition;

    @media (max-width: $screen-sm-max) {
      letter-spacing: 0.08em;
      color: #d5d5d5;
    }

    i {
      margin-right: 0.5em;
      font-size: 1em;
      display: inline-block;
      width: 25px;
      text-align: center;

      @media (max-width: $screen-xs-min) {
        width: 20px;
        font-size: 0.8em;
      }
    }

    &::after {
      display: none;
    }

    &:hover {
      color: #515151;
    }
  }
}
</style>

<style>
.main-nav__sub-nav a i svg {
  width: auto;
  height: 1em;
  fill: currentColor;
  margin-bottom: -0.1em;
}
</style>
